import React, { useState } from "react";
import axios from "axios";
import "./modal.css";

const Modal = ({ closeModal }) => {
  const initialState = {
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    address: "",
    province: "",
    education_level: "",
    description: "",
  };

  const [formData, setFormData] = useState(initialState);
  const [statusMessage, setStatusMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setFormData({ ...initialState });

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatusMessage("");

    try {
      console.log("Submitting volunteer form:", formData);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/volunteer`,
        formData
      );

      console.log("Volunteer form submitted successfully:", response.data);
      clearState();
      setStatusMessage("Application sent! We'll get back to you shortly.");
      e.target.reset();
    } catch (error) {
      console.error("Error submitting volunteer form:", error);
      const errorMessage = error.response?.data?.message || "Couldn't send. Check your network connection";
      setStatusMessage(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="modalBackground">
        <div className="modalContainer">
          <div className="closeBtn">
            <button onClick={() => closeModal(false)}>X</button>
          </div>

          <div className="header">
            <h1>Fill the form below to become a volunteer</h1>
          </div>
          <div className="modalContent">
            <div className="form-wrapper">
              <form onSubmit={sendEmail}>
                <div className="formGroup">
                  <input
                    type="text"
                    name="first_name"
                    placeholder="First Name"
                    value={formData.first_name}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="text"
                    name="last_name"
                    placeholder="Last Name"
                    value={formData.last_name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="formGroup">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="tel"
                    name="phone_number"
                    placeholder="Phone Number"
                    value={formData.phone_number}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="formGroup">
                  <input
                    type="text"
                    name="address"
                    placeholder="Address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="text"
                    name="province"
                    placeholder="Province"
                    value={formData.province}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="formSingle">
                  <select
                    name="education_level"
                    id="education_level"
                    value={formData.education_level}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>
                      Level of education
                    </option>
                    <option value="Undergraduate">Undergraduate</option>
                    <option value="Masters">Masters</option>
                    <option value="PhD">PhD</option>
                    <option value="Diploma/Certificate">
                      Diploma/Certificate
                    </option>
                  </select>
                </div>
                {/* <div className="formGroup">
                <input
                  type="email"
                  name="school_email"
                  placeholder="School e-mail address"
                  required
                />
                <input
                  type="number"
                  name="graduation_year"
                  placeholder="Expected graduation year"
                  required
                />
              </div> */}
                <div className="description">
                  <textarea
                    name="description"
                    id="description"
                    cols="30"
                    rows="10"
                    placeholder="A brief description of yourself (100 word maximum)"
                    value={formData.description}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <p className="alertMsg">{statusMessage}</p>

                <input
                  type="submit"
                  value={isSubmitting ? "Sending..." : "Send"}
                  className="btnPrimary"
                  style={{ width: "100%" }}
                  disabled={isSubmitting}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
